module.exports = "@media print{\r\n    .table-responsive table td{\r\n        font-size:0.8em;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/avail-blocked-inter-dq-corner/avail-blocked-inter-dq-corner.component.css
// module id = ./src/app/reports/avail-blocked-inter-dq-corner/avail-blocked-inter-dq-corner.component.css
// module chunks = main